import { IProduct } from '../product/product.interfaces'

export interface ICartItem {
  product: IProduct
  quantity: number
}

export interface ICartUpsell {
  promotionalText: string
  product: string
}

export interface IShopifyCartItem {
  id: number
  product_id: number
  quantity: number
}

export interface IShopifyCart {
  items: IShopifyCartItem[]
}
